import FilterI18n from './src/index';

export { FilterI18n };
